import { animated, useSpring, useSprings } from '@react-spring/web';
import React, { useState } from 'react';
import styled from 'styled-components';
import { MediaAssets } from '../services/ofertas-service/models/ofertas';

const CarImagesRow = styled(animated.div)<{ imageWidth: number }>`
	width: ${(props) => props.imageWidth}%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	position: relative;
`;

const CarImage = styled(animated.img)`
	z-index: -1;
	height: 100%;
`;

export const Carrousel = ({
	mediaAssets,
}: {
	mediaAssets: MediaAssets;
}): React.ReactElement => {
	const turntable = [
		'D6Turntable1',
		'D6Turntable3',
		'D6Turntable5',
		'D6Turntable6',
		'D6Turntable7',
		'D6Turntable9',
		'D6Turntable12',
	];
	const carImages = turntable
		.map((turntable) => mediaAssets[turntable])
		.filter((image) => image !== null && image !== undefined);

	const baseTime = 15000;
	const time = baseTime * carImages.length;

	const imageWidth = 65;

	const [reset, setReset] = useState(false);
	const [opacityReset, setOpacityReset] = useState(false);

	const props = useSpring({
		from: { x: 30 },
		to: async (next) => {
			while (true) {
				if (reset) {
					await next({ x: 30, config: { duration: 500 } });
					setReset(false);
				} else {
					await next({
						x: -imageWidth * carImages.length + 100,
						config: { duration: time },
					});
					setReset(true);
					setOpacityReset(false);
				}
			}
		},
	});

	const delayFactor = 1.2;

	const fades = useSprings(
		carImages.length,
		carImages.map((_, i) => ({
			from: { opacity: 1 },
			to: async (next) => {
				if (opacityReset) {
					await next({ opacity: 1, config: { duration: 500 }, delay: 15000 });
				} else {
					await next({ opacity: 0.25, config: { duration: 3000 } });
					setOpacityReset(true);
				}
			},
			delay: 4000 + (time / carImages.length) * i * delayFactor,
			reset: reset,
		})),
	);

	return (
		<CarImagesRow
			imageWidth={imageWidth}
			style={{
				transform: props.x.to((x) => `translateX(${x}%)`),
			}}
			className="car-images-row"
		>
			{carImages.map((image, index) => (
				<CarImage
					key={index}
					src={`${image}`}
					alt={`${image}`}
					style={{ width: `${imageWidth}%`, opacity: fades[index].opacity }}
					className="car-image"
				/>
			))}
		</CarImagesRow>
	);
};
